import React, { useEffect, useMemo, useState } from "react";
import Container from "../components/Layout/Container";
import ContentBlock from "../components/Layout/ContentBlock";
import FilterMenu from "../components/Layout/FilterMenu";
import TableFilterBox from "../components/common/TableFilterBox";
import ContentValidation from "../components/common/ContentValidation";
import Pagination from "../components/Dashboard/items/Pagination";
import { getDateFormat, prettyDateFormat } from "../helpers/Utils";
import {
  ButtonSmall,
  CheckBoxInput,
  SelectForm,
} from "../components/common/Buttons";
import RangePickerComp from "../components/common/RangePickerComp";
import { Tooltip, Select } from "antd";
import { IconDot, IconSearch } from "../components/Layout/Icons";
import { useDispatch, useSelector } from "react-redux";
import {
  exportToAlso,
  getAlsoIncomes,
  getAlsoIncomesOptions,
  setAlsoIncomeFilters,
} from "../redux/Actions/also_incomes_action";
import ModalAlsoIncomeModule from "../components/AlsoIncomeModule/ModalAlsoIncomeModule";
import { DebounceSelect } from "../components/common";
import errorHandler from "../helpers/ErrorHandler";
import Axios from "axios";
import { handleKeyDown, onChangeUseState } from "../helpers/FunctionsGlobal";
import InputText from "../components/orders/accepted_orders/InputFilter";
import AlsoIncomesTabUi from "./AlsoIncomesTabUi";
import { addOverFlow, removeOverFlow } from "../helpers/modalFunc";
import { Label } from "../components/globals";

const filterInitial = {
  date: ["", ""],
  arrival_date: ["", ""],
  status: undefined,
  user_id: undefined,
  close_date: ["", ""],
  earned: "",
  product: undefined,
  order_number: "",
  supplier_invoice_number: "",
  also_no: "",
  supplier_code: "",
  add_to: undefined,
};
export default function AlsoIncomeModuleScreen({
  match,
  history,
  tabId,
  setTabId,
  lockedStatus,
}) {
  console.log("AlsoIncomeModuleScreen");
  const dispatch = useDispatch();

  const { totals, current, loading, data, options, show_data, alsoIncomeFilters } = useSelector(
    (state) => state.custom
  );

  const role_identifier = useSelector((state) => state.auth.user.role);
  const permissions = useSelector(
    (state) => state.auth.user.user_role?.permissions || {}
  );
  const canCreatePo = !!permissions.also_income_module_create_po;

  // locked tabs (Review/Pending) always start from a clean, status-forced filter set
  const [page, setPage] = useState(lockedStatus ? 1 : alsoIncomeFilters.page);
  const [perPage, setPerPage] = useState(lockedStatus ? 50 : alsoIncomeFilters.perPage);
  const [filters, setFilters] = useState(lockedStatus ? filterInitial : alsoIncomeFilters.filters);
  const [filterString, setfilterString] = useState(
    lockedStatus ? `&q[status_eq]=${lockedStatus}` : alsoIncomeFilters.filterString
  );
  const [selected, setSelected] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);


  const [modalPreview, setModalPreview] = useState(false);

  useEffect(() => {
    if (lockedStatus) return;

    dispatch(setAlsoIncomeFilters({
      page,
      perPage,
      filters,
      filterString,
    }));
  }, [page, perPage, filters, filterString]);

  useEffect(() => {
    console.log("2");
    if (!modalPreview) dispatch(getAlsoIncomes(page, perPage, filterString));
  }, [filterString, page, perPage, modalPreview]);
  useEffect(() => {
    dispatch(getAlsoIncomesOptions());
  }, []);
  useEffect(() => {
    if (modalPreview === 0) {
      addOverFlow();
    } else {
      removeOverFlow();
    }
  }, [modalPreview]);
  console.log({ options });

  // useEffect(() => {
  //   onFilter();
  // }, [
  //   filters.date,
  //   filters.status,
  //   filters.user_id,
  //   filters.close_date,
  //   filters.earned,
  // ]);

  const onFilter = () => {
    let filterParams = "";

    if (lockedStatus) {
      filterParams += `&q[status_eq]=${lockedStatus}`;
    } else if (filters.status) {
      filterParams += `&q[status_eq]=${filters.status}`;
    }
    if (filters.date.every((d) => d)) {
      filterParams += `&q[created_at_gteq]=${filters.date[0]}`;
      filterParams += `&q[created_at_lteq]=${filters.date[1]}`;
    }
    if (filters.arrival_date.every((d) => d)) {
      filterParams += `&q[arrival_date_gteq]=${filters.arrival_date[0]}`;
      filterParams += `&q[arrival_date_lteq]=${filters.arrival_date[1]}`;
    }
    if (filters.user_id) filterParams += `&q[user_id_eq]=${filters.user_id}`;
    if (filters.close_date.every((d) => d)) {
      filterParams += `&q[close_date_gteq]=${filters.close_date[0]}`;
      filterParams += `&q[close_date_lteq]=${filters.close_date[1]}`;
    }
    // ???
    if (filters.earned) filterParams += `&q[earned_eq]=${filters.earned}`;
    if (filters.add_to) filterParams += `&q[add_to_eq]=${filters.add_to}`;
    if (filters.order_number)
      filterParams += `&q[order_nr_cont_any]=${filters.order_number}`;
    if (filters.supplier_invoice_number)
      filterParams += `&q[invoice_number_or_suppliers_invoice_invoice_number_cont_any]=${filters.supplier_invoice_number}`;
    if (filters.also_no)
      filterParams += `&q[also_no_cont_any]=${filters.also_no}`;
    if (filters.supplier_code)
      filterParams += `&q[supplier_code_or_supplier_name_cont_any]=${filters.supplier_code}`;
    if (filters.product)
      filterParams += `&q[also_income_item_sku_or_also_income_item_product_title_cont_any]=${filters.product}`;
    console.log(filterParams);

    setfilterString(filterParams);
    setPage(1);
  };
  const renderCustomButton = () => {
    return (
      <>
        {canCreatePo && (
          <button
            type="button"
            className="btn btn-sm btn-primary float-left ml-3"
            onClick={() => {
              setModalPreview(0);
            }}
          >
            {"New document"}
          </button>
        )}
        {"accounting" == role_identifier && (
          <div className="dropdown">
            <button
              className="btn btn-sm btn-dark float-right mr-3"
              onClick={() => exportToAlso(selected)}
            >
              Export
            </button>
          </div>
        )}
      </>
    );
  };

  const fetchOptions = async (value) => {
    try {
      let api_url = `/api/v1/also_incomes/simple_products?q[sku_or_product_title_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      console.log({ data });
      const valArr = data?.data?.filter((d) => d.sku) || [];
      return (
        [
          {
            label: "No data selected",
            value: "",
          },
          ...valArr.map((e) => {
            return {
              ...e,
              value: e.sku,
              label: `${e.sku} - ${e.product_title}`,
            };
          }),
        ] || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  useEffect(() => {
    Axios.get("/api/v1/also_incomes/stores")
      .then((res) => {
        const stores = res.data.stores || {};
        const groups = Object.keys(stores).map((groupKey) => ({
          label: groupKey,
          options: Object.entries(stores[groupKey]).map(([code, label]) => ({
            label: label,
            value: code,
          })),
        }));
        setWarehouseOptions(groups);
      })
      .catch((err) => console.error("Error fetching warehouse options:", err));
  }, []);

  console.log({ perPage, page });

  return (
    <Container
      location={{
        locationName: "3PL incomes",
        locationUrl: "match.url",
      }}
    >
      <ContentBlock>
        <FilterMenu
          totals={totals}
          length={data.length}
          noLowerCase={true}
          text2="3PL incomes"
          onChangeCountPage={setPerPage}
          countPage={perPage}
        />
      </ContentBlock>
      <div style={{ marginLeft: 15 }}>
        <AlsoIncomesTabUi
          tabId={tabId}
          setTabId={setTabId}
          counts={{
            all_documents: show_data.total_all,
            require_review: show_data.total_require_review,
            pending: show_data.total_pending,
          }}
        />
      </div>
      <ContentBlock containerClass="py-1">
        <TableFilterBox
          filter={true}
          onFilter={() => onFilter()}
          clearFilter={() => setFilters(filterInitial)}
          button1={renderCustomButton()}
        >
          <div className="px-1">
            <InputText
              name="order_number"
              placeholder="Supplier order number"
              style={{ width: 165, fontSize: "0.75rem" }}
              value={filters.order_number}
              onKeyDown={(e) => handleKeyDown(e, onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
          <div className="px-1">
            <InputText
              name="supplier_invoice_number"
              placeholder="Supplier invoice number"
              style={{ width: 165, fontSize: "0.75rem" }}
              value={filters.supplier_invoice_number}
              onKeyDown={(e) => handleKeyDown(e, onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
          <div className="px-1">
            <div className="form-group order-input-form-group">
              <Label className="text-sm-label">Creation date</Label>
              <RangePickerComp
                placeholder={["Start time", "End time"]}
                value={[
                  getDateFormat(filters.date[0]),
                  getDateFormat(filters.date[1]),
                ]}
                onChange={(_, date) =>
                  setFilters((prev) => ({ ...prev, date }))
                }
                ignoreDisabledDate={true}
              />
            </div>
          </div>
          <div className="px-1">
            <div className="form-group order-input-form-group">
              <Label className="text-sm-label">Arrival date</Label>
              <RangePickerComp
                placeholder={["Start time", "End time"]}
                value={[
                  getDateFormat(filters.arrival_date[0]),
                  getDateFormat(filters.arrival_date[1]),
                ]}
                onChange={(_, date) =>
                  setFilters((prev) => ({ ...prev, arrival_date: date }))
                }
                ignoreDisabledDate={true}
              />
            </div>
          </div>

          <div className="px-1">
            <DebounceSelect
              label="Product title or sku"
              showSearch={true}
              value={filters.product || undefined}
              placeholder={"Enter"}
              fetchOptions={fetchOptions}
              onChange={(val) => {
                setFilters((prev) => ({
                  ...prev,
                  product: val.value,
                }));
              }}
              style={{
                width: "165px",
              }}
            />
          </div>
          <div className="px-1">
            <InputText
              name="supplier_code"
              placeholder="Supplier code"
              style={{ width: 165, fontSize: "0.75rem" }}
              value={filters.supplier_code}
              onKeyDown={(e) => handleKeyDown(e, onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
          <div className="px-1">
            <SelectForm
              placeholder="Manager"
              dropdownMatchSelectWidth={false}
              style={{ width: 165 }}
              options={
                options?.managers
                  ? [
                    {
                      label: "All",
                      value: "",
                    },
                    ...options?.managers,
                  ]
                  : []
              }
              onChange={(user_id) =>
                setFilters((prev) => ({ ...prev, user_id }))
              }
              value={filters.user_id}
            />
          </div>
          <div className="px-1">
            <Label className="text-sm-label">Department</Label>
            <Select
              placeholder="Department"
              style={{ width: 165 }}
              dropdownMatchSelectWidth={false}
              options={warehouseOptions}
              onChange={(add_to) =>
                setFilters((prev) => ({ ...prev, add_to }))
              }
              value={filters.add_to}
            />
          </div>
          <div className="px-1">
            <InputText
              name="also_no"
              placeholder="PO No."
              style={{ width: 165, fontSize: "0.75rem" }}
              value={filters.also_no}
              onKeyDown={(e) => handleKeyDown(e, onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>

          {!lockedStatus && (
            <div className="px-1">
              <SelectForm
                placeholder="Status"
                dropdownMatchSelectWidth={false}
                options={[
                  {
                    label: "All",
                    value: "",
                  },
                  {
                    label: "New",
                    value: "new",
                  },
                  {
                    label: "In progress",
                    value: "in_progress",
                  },
                  {
                    label: "Completed",
                    value: "completed",
                  },
                  {
                    label: "Failed",
                    value: "failed",
                  },
                  {
                    label: "Canceled",
                    value: "canceled",
                  },
                  {
                    label: "Pending",
                    value: "pending",
                  },
                  {
                    label: "Require review",
                    value: "require_review",
                  },
                  {
                    label: "Income started",
                    value: "income_started",
                  },
                  {
                    label: "Income ended",
                    value: "income_ended",
                  },
                  {
                    label: "Shortcoming",
                    value: "shortcoming",
                  },
                ]}
                onChange={(status) => setFilters((prev) => ({ ...prev, status }))}
                style={{ width: 165 }}
                value={filters.status}
              />
            </div>
          )}
        </TableFilterBox>
        <div>
          <ContentValidation loader={loading} array={data}>
            <div className="table-responsive" style={{ overflowX: "auto", overflowY: "visible" }}>
              <table className="table mt-3 line-height-normal" style={{ minWidth: "1200px" }}>
                <thead>
                  <tr className="text-muted">
                    <th className="text-black" style={{ minWidth: "50px" }}>
                      <CheckBoxInput
                        checked={
                          selected.length ==
                          data?.filter((d) => !d.in_progress_at).length
                        }
                        onChange={() => {
                          if (
                            selected.length ==
                            data?.filter((d) => !d.in_progress_at).length
                          ) {
                            setSelected([]);
                          } else {
                            setSelected(
                              data
                                ?.filter((d) => !d.in_progress_at)
                                .map((d) => d.id) || []
                            );
                          }
                        }}
                      />
                    </th>
                    <th className="text-black" style={{ minWidth: "120px" }}>Document No.</th>
                    <th className="text-black" style={{ minWidth: "110px" }}>Creation date</th>
                    <th className="text-black" style={{ minWidth: "120px" }}>Status</th>
                    <th className="text-black" style={{ minWidth: "100px" }}>Supplier code</th>
                    <th className="text-black" style={{ minWidth: "100px" }}>Supplier order number</th>
                    <th className="text-black" style={{ minWidth: "100px" }}>Supplier invoice number</th>
                    <th className="text-black" style={{ minWidth: "100px" }}>Manager</th>
                    <th className="text-black" style={{ minWidth: "100px" }}>Last Editor</th>
                    <th className="text-black" style={{ minWidth: "80px" }}>PO No.</th>
                    <th className="text-black" style={{ minWidth: "100px" }}>Pending till</th>
                    <th className="text-black" style={{ minWidth: "100px" }}>Arrival date</th>
                    <th className="text-black" style={{ minWidth: "120px" }}>Processing dates</th>
                    <th className="text-black" style={{ minWidth: "120px" }}>Department</th>
                    <th className="text-black" style={{ minWidth: "100px" }}>Total/Used qty</th>
                    <th className="text-black" style={{ minWidth: "60px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {!loading &&
                    current == "AlsoIncomes" &&
                    data.map((item, idx) => {
                      return (
                        <AlsoIncomeItem
                          key={item.id}
                          idx={idx}
                          history={history}
                          selected={selected.includes(item.id)}
                          setSelected={() =>
                            setSelected((prev) => {
                              let obj = [...prev];
                              if (obj.includes(item.id)) {
                                return obj.filter((value) => value !== item.id);
                              } else {
                                return [...obj, item.id];
                              }
                            })
                          }
                          {...item}
                        />
                      );
                    })}
                </tbody>
              </table>
              <Pagination
                page={page}
                pageCount={perPage}
                totals={totals}
                setPagination={setPage}
              />
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>

      {typeof modalPreview == "number" && (
        <ModalAlsoIncomeModule
          id={modalPreview}
          modalFunc={setModalPreview}
          history={history}
        />
      )}
    </Container>
  );
}

const AlsoIncomeItem = ({
  id,
  status,
  user_full,
  editor_full,
  created_at,
  also_no,
  add_to,
  document_no,
  history,
  selected,
  setSelected,
  review_at,
  arrival_date,
  order_nr,
  order_date,
  supplier_code,
  in_progress_at,
  qty,
  used_qty,
  api_errors,
  canceled_at,
  income_started_at,
  income_ended_at,
  invoice_number,
}) => {
  const status_color = useMemo(() => {
    let color = "#CBCBCB";
    let text =
      typeof status == "string"
        ? `${status.charAt(0).toUpperCase()}${status
          .toLowerCase()
          .slice(1)
          .split("_")
          .join(" ")}`
        : "-";
    // let text = "Dar nenusiųsta pajamavimui";
    if (status == "completed") {
      color = "#ADCB35";
      // text = "Pilnai supajamuota";
    } else if (status == "new") {
      color = "#00AAA0";
    } else if (status == "require_review") {
      color = "#8678AB";
    } else if (status == "pending") {
      color = "#F29302";
    } else if (status == "in_progress") {
      color = "#FFCC69";
      // text = "Pradėta pajamuota";
    } else if (status == "income_started") {
      color = "#efcd0a";
    } else if (status == "income_ended") {
      color = "#199a1a";
    } else if (status == "failed") {
      color = "#FF0000";
      text = api_errors || "";
    } else if (status == "canceled") {
      color = "#742a40";
      text = (
        <>
          Canceled at:
          <br />
          {canceled_at ? prettyDateFormat(canceled_at) : "None"}
        </>
      );
    }
    return {
      color,
      text,
    };
  }, [status]);
  return (
    <tr className="align-middle tableColumn">
      <td className="align-middle">
        {" "}
        <CheckBoxInput
          disabled={in_progress_at}
          checked={selected}
          onChange={() => setSelected()}
        />
      </td>
      <td className="align-middle">{document_no}</td>
      <td className="align-middle">{prettyDateFormat(created_at)}</td>
      <td className="align-middle">
        <div className="d-flex flex-row align-items-center">
          <div>
            <IconDot color={status_color.color} className={`text-xl dotFix`} />
          </div>
          <Tooltip
            placement="top"
            title={
              <span className="text-sm">
                <div style={{ color: "#fff" }}>{status_color.text}</div>
              </span>
            }
          >
            <p style={{ margin: 0 }}>{status_color.text}</p>
          </Tooltip>
        </div>
      </td>
      <td className="align-middle">{supplier_code}</td>
      <td className="align-middle">
        <div>
          {order_nr && <div>No: {order_nr}</div>}
          {order_date && <div className="text-xs">Date: {order_date}</div>}
        </div>
      </td>
      <td className="align-middle">{invoice_number}</td>
      <td className="align-middle">{user_full}</td>
      <td className="align-middle">{editor_full}</td>
      <td className="align-middle">{also_no}</td>
      <td className="align-middle">{review_at}</td>
      <td className="align-middle">{arrival_date}</td>
      <td className="align-middle">
        <div className="text-xs">
          <Tooltip placement="top" title={"Start date"}>{income_started_at ?? '-'} </Tooltip>
          <br />
          <Tooltip placement="top" title={"End date"}>{income_ended_at ?? '-'}</Tooltip>
        </div>
      </td>
      <td className="align-middle">
        {add_to?.startsWith("vv_") ? (
          <>
            <div>Verslo Vartai</div>
            <div style={{ fontSize: 12 }}>{add_to}</div>
          </>
        ) : (
          <>
            <div>Electronic trade</div>
            <div style={{ fontSize: 12 }}>{add_to}</div>
          </>
        )}
      </td>
      <td className="align-middle">
        {qty}/{used_qty}
      </td>
      <td className="align-middle d-flex justify-content-end">
        <ButtonSmall
          className={"ml-2"}
          onClick={() => history.push(`/also_income_module/${id}`)}
        >
          <IconSearch color="#fff" />
        </ButtonSmall>
      </td>
    </tr>
  );
};
